import React, { useEffect } from "react"
import './footer.css'
import lumero from "../../assets/Lumero.png"
import Aos from 'aos';
import 'aos/dist/aos.css';

const Footer = () => {

  //Animation
  useEffect(() => {
    Aos.init({
        duration: 2000,
        once: false,
    });
  },[]);

  return (
    <>
      <footer className="footer container">
        <div data-aos="fade-up" className='body__section'>
          <div className='img'>
            <img src={lumero} alt='' />
          </div>
          <p>© 2022. All rights reserved by Lumerocode.</p>
        </div>
      </footer>
    </>
  )
}

export default Footer
